'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$DeleteGroupRequest(code) {
  this.Z3 = null;
  this.Z3 = code;
}
export { $c_Lpresto_types$proto$DeleteGroupRequest as $c_Lpresto_types$proto$DeleteGroupRequest };
$p = $c_Lpresto_types$proto$DeleteGroupRequest.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$DeleteGroupRequest;
/** @constructor */
function $h_Lpresto_types$proto$DeleteGroupRequest() {
}
export { $h_Lpresto_types$proto$DeleteGroupRequest as $h_Lpresto_types$proto$DeleteGroupRequest };
$h_Lpresto_types$proto$DeleteGroupRequest.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$proto$DeleteGroupRequest) && (this.Z3 === x$0.Z3)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "DeleteGroupRequest";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Z3;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$DeleteGroupRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kU)));
}
export { $isArrayOf_Lpresto_types$proto$DeleteGroupRequest as $isArrayOf_Lpresto_types$proto$DeleteGroupRequest };
var $d_Lpresto_types$proto$DeleteGroupRequest = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$DeleteGroupRequest, "presto.types$proto$DeleteGroupRequest", ({
  kU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$DeleteGroupRequest as $d_Lpresto_types$proto$DeleteGroupRequest };
//# sourceMappingURL=presto.types$proto$-Delete-Group-Request.js.map
